"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LIST_SELECTED = exports.LIST_CONTAINER_CHECKBOX = exports.LIST_MAIN_CONTENT = exports.LIST_CONTENT_DATA = exports.LIST_CONTENT = exports.LIST_CHECKBOX = exports.LIST_ACTION_ICON = exports.LIST = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
exports.LIST = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-list");
exports.LIST_ACTION_ICON = exports.LIST + '-action-icon';
exports.LIST_CHECKBOX = exports.LIST + '-checkbox';
exports.LIST_CONTENT = exports.LIST + '-content';
exports.LIST_CONTENT_DATA = exports.LIST + '-content-data';
exports.LIST_MAIN_CONTENT = exports.LIST + '-main-content';
exports.LIST_CONTAINER_CHECKBOX = exports.LIST + '-container-checkbox';
exports.LIST_SELECTED = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-selected");
